import { api } from "@/api/client";
import { PaginatedSearch } from "@/types";
import { convertToURLSearchParams } from "@/util";

export type ResultType = "Contractor" | "Project" | "Welder" | "Scope of Work" | "Test Event" | "Certificate" | "Test";

export type GlobalSearchResult = {
  id: string;
  name: string;
  description: string;
  resultType: ResultType;
  pinned: boolean;
};

export interface GlobalSearchFilters extends PaginatedSearch {
  ownerId?: string;
  specialistId?: string;
  searchString: string;
}

export interface IncompleteItemsSearchFilters extends PaginatedSearch {
  projectId?: string;
  contractorId?: string;
  searchString: string;
}

export function globalSearch(filters: Partial<GlobalSearchFilters>) {
  const params = convertToURLSearchParams(filters);
  return api.getPaginated<GlobalSearchResult[]>(`williams/search?${params}`);
}

export function getIncompleteItems(filters: Partial<IncompleteItemsSearchFilters>) {
  const params = convertToURLSearchParams(filters);
  return api.getPaginated<GlobalSearchResult[]>(`williams/search/incomplete?${params}`);
}
